import React from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { videoLessons } from "@/content/videoLessons";
import VideoLessonCard from "@/components/videos/VideoLessonCard";
import SocialFollowLinks from "@/components/videos/SocialFollowLinks";

export default function ShortLessonsSection() {
  const featured = videoLessons.slice(-3).reverse();

  return (
    <section className="bg-[#f3efe6] px-4 py-20 text-slate-950 sm:px-6 lg:px-8" aria-labelledby="short-lessons-title">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-3xl">
            <p className="mb-3 text-xs font-black uppercase tracking-[0.22em] text-amber-800">
              Free short lessons for UK law students
            </p>
            <h2 id="short-lessons-title" className="text-4xl font-black tracking-tight sm:text-5xl">
              Learn law in under a minute.
            </h2>
            <p className="mt-4 max-w-2xl text-lg leading-8 text-slate-700">
              {videoLessons.length} practical lessons on case reading, legal reasoning, research, OSCOLA, seminar preparation and responsible AI. Watch the latest lessons here, then continue with the full free guide.
            </p>
          </div>
          <Link
            href="/videos"
            prefetch={false}
            className="inline-flex w-fit items-center gap-2 rounded-full bg-slate-950 px-6 py-3 text-sm font-black !text-white transition hover:bg-emerald-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-950"
          >
            View all short lessons
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {featured.map((lesson, index) => (
            <VideoLessonCard key={lesson.slug} lesson={lesson} priority={index === 0} />
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 rounded-2xl border border-slate-900/10 bg-white/65 p-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm font-semibold text-slate-700">
            Follow Durmah for new UK law study lessons and practical revision methods.
          </p>
          <SocialFollowLinks source="homepage_short_lessons" compact />
        </div>
        <p className="mt-5 text-xs leading-5 text-slate-600">
          Visuals in these short lessons are AI-generated illustrations. The educational guidance is prepared and reviewed by Durmah. Always check the original authority and your institution's rules.
        </p>
      </div>
    </section>
  );
}
